"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectStep = void 0;
// Project lifecycle step catalogue. Merged from backend's
// `pm/types/index.ts#PROJECT_STEP` and frontend's `utils/enums.ts#ProjectStep`
// (identical 13-member set).
//
// Implementation note (mirrors accounts/account-type.ts): member values are
// typed as the full union so `[ProjectStep.X, ProjectStep.Y].includes(z)`
// patterns keep working without per-site casts. Narrow literal types are
// still available via `(typeof PROJECT_STEP_LITERAL)['X']`.
const PROJECT_STEP_LITERAL = {
    PROJECT_INITIALIZED: 'PROJECT_INITIALIZED',
    PROJECT_REQUESTED: 'PROJECT_REQUESTED',
    PROJECT_ACCEPTED: 'PROJECT_ACCEPTED',
    PROJECT_IN_PROGRESS: 'PROJECT_IN_PROGRESS',
    PROJECT_FILE_COMPLETED: 'PROJECT_FILE_COMPLETED',
    PROJECT_FILE_SENT: 'PROJECT_FILE_SENT',
    PROJECT_FILE_SUBMITTED: 'PROJECT_FILE_SUBMITTED',
    PROJECT_FILE_REFUSED: 'PROJECT_FILE_REFUSED',
    PROJECT_ORDERED: 'PROJECT_ORDERED',
    PROJECT_PAIED: 'PROJECT_PAIED',
    PROJECT_COMPLETED: 'PROJECT_COMPLETED',
    PROJECT_ABANDONED: 'PROJECT_ABANDONED',
    PROJECT_REFUSED: 'PROJECT_REFUSED',
};
exports.ProjectStep = PROJECT_STEP_LITERAL;
//# sourceMappingURL=steps.js.map